import Vue from 'vue';
import VueRouter from 'vue-router';
import EducationOverview from '@/components/education/education-overview';

Vue.use(VueRouter);

const routes = [
    { path: window.settings.educationPage, component: EducationOverview },
    { path: window.settings.educationPage + '/*', component: EducationOverview }
];

export default new VueRouter({
    routes,
    mode: 'history'
});
